import { CourtSituationInteractor, CourtSituationRequest, CourtSituationStructRequest} from "../../Coordinator/CourtSituation/CourtSituationInteractor";

export class CourtSituationViewModel {
    private interactor: CourtSituationInteractor;

	constructor() {
		this.interactor = new CourtSituationInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new CourtSituationRequest(
            obj["sgepsituacaoquadra"] ? parseInt(obj["sgepsituacaoquadra"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new CourtSituationStructRequest(
            obj["sgepsituacaoquadra"] ? parseInt(obj["sgepsituacaoquadra"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}